package com.ustadmobile.core.impl.appstate

data class OverflowItem(
    val label: String,
    val onClick: () -> Unit,
)

